import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as AlterListMembershipActionMetadataKeys from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionMetadataKeys';
export default class AlterListMembershipActionMetadata extends Record({
  [AlterListMembershipActionMetadataKeys.ACTION_TYPE]: ActionTypes.ALTER_LIST_MEMBERSHIP,
  [AlterListMembershipActionMetadataKeys.LIST_ID]: null,
  [AlterListMembershipActionMetadataKeys.SHOULD_ADD]: null
}, 'AlterListMembershipActionMetadata') {}